// extracted by mini-css-extract-plugin
export default {"wordContainer":"word-container_wordContainer__6gSM2","wordImage":"word-container_wordImage__PqteU","word":"word-container_word__vn+3e"};